<div class="breadcrumb">
	<div class="breadcrumb-item" *ngFor="let breadcrumb of breadcrumbs; let i = index">
		<a [routerLink]="[breadcrumb.url]" translate>{{breadcrumb.label}}</a>
		<span *ngIf="i < breadcrumbs.length - 1">/</span> 
	</div>	
</div>